export default __webpack_public_path__ + "static/media/lincoln.0f0c2383.svg";